<template>
  <button
    :class="choiceClasses"
    @click="pick"
  >
    <img
      :src="src"
      alt=""
      draggable="false"
      class="image"
    />
    <span :class="circleClasses"></span>
  </button>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { EventBus } from '@/EventBus'
import { trekChoice } from '@/utils/trek'

export default {
  name: 'Choice',
  data () {
    return {
      active: false
    }
  },
  props: {
    filename: {
      type: String,
      required: true
    },
    gender: {
      type: String,
      validator: function (value) {
        return ['male', 'female'].indexOf(value) !== -1
      },
      required: true
    },
    age: {
      type: String,
      validator: function (value) {
        return ['young', 'old'].indexOf(value) !== -1
      }
    },
    base: {
      type: Boolean,
      default: false
    }
  },
  created () {
    if (this.base) {
      this.active = this.base
    }
  },
  mounted () {
    EventBus.$on('characterChoice', filename => {
      this.active = (filename === this.filename)
    })
  },
  methods: {
    pick () {
      trekChoice(this.filename)
      this.active = true
      EventBus.$emit('characterChoice', this.filename)

      setTimeout(() => {
        VueScrollTo.scrollTo('.chapter-1', 500)
      }, 500)
    }
  },
  computed: {
    src () {
      return require(`@/assets/images/${this.filename}.gif`)
    },
    choiceClasses () {
      return {
        'choice': true,
        'is-selected': this.active
      }
    },
    circleClasses () {
      return {
        'circle': true,
        'active': this.active
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.choice {
  float: left;
  width: 25%;
  background: none;
  border: none;
  padding: 0 10px;
  box-shadow: none;
  outline: 0;
  font-size: 0;
  cursor: pointer;
  position: relative;
  filter: grayscale(100%);

  @media (min-width: 768px) {
    padding: 0 60px;
  }
}

.is-selected {
  filter: grayscale(0%);
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.33);
  }
  80%,
  100% {
    opacity: 0;
  }
}

.circle {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  transition: transform 0.3s cubic-bezier(0.47, 0, 0.75, 1.11);
  will-change: transform;
  top: 34px;
  background-color: #D8D8D5;
  transform: scale(0);
  width: 75px;
  height: 75px;
  border-radius: 50%;
  z-index: 1;

  @media (min-width: 768px) {
    top: 20px;
    width: 150px;
    height: 150px;
  }
}

.active {
  transform: scale(1);

  &::before {
    content: '';
    position: relative;
    display: block;
    width: 130%;
    height: 0;
    padding-bottom: 130%;
    margin-left: -15%;
    margin-top: -15%;
    border-radius: 50%;
    background-color: $c-red;
    animation: pulse-ring 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
  }
}

.image {
  max-width: 100%;
  height: auto;
  display: block;
  position: relative;
  z-index: 2;
}
</style>
